import { AppAction, ActionType } from './actions';
import { AppState } from './states';

const reducer = (state: AppState, action: AppAction): AppState => {
  switch (action.type) {
    case ActionType.CHANGE_SAMPLE_VALUE:
      return { ...state, sampleState: action.payload };
    default:
      return state;
  }
};

export default reducer;
